import React, {Fragment} from "react";
import { FixedSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import { CircularProgress, Avatar, ListItemAvatar, ListItemText, ListItem} from "@mui/material";
import { withStyles } from '@mui/styles';

const styles = (theme) => ({
    root: {
      marginLeft: theme.spacing(9),
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.down("sm")]: {
        marginLeft: 0,
        
      },
    },
    paper: {
      margin: theme.spacing(2),
    },
    form: {
      margin: theme.spacing(1),
      flex: 1
    },
    avatar: {
      color: theme.palette.getContrastText(theme.palette.secondary.light),
      backgroundColor: theme.palette.secondary.light,
    }
  });
  
function ExampleWrapper({
  // Are there more items to load?
  // (This information comes from the most recent API request.)
  hasNextPage,

  // Are we currently loading a page of items?
  // (This may be an in-flight flag in your Redux store for example.)
  isNextPageLoading,

  // Array of items loaded so far.
  items,

  // Callback function responsible for loading the next page of items.
  loadNextPage,

  classes,

  onClick
}) {
  // If there are more items to be loaded then add an extra row to hold a loading indicator.
  const itemCount = hasNextPage ? items.length + 1 : items.length;

  // Only load 1 page of items at a time.
  // Pass an empty callback to InfiniteLoader in case it asks us to load more than once.
  const loadMoreItems = isNextPageLoading ? () => {} : loadNextPage;

  // Every row is loaded except for our loading indicator row.
  const isItemLoaded = index => !hasNextPage || index < items.length;

  // console.log(items);
  // Render an item or a loading indicator.
  const Item = ({ index, style }) => {
    let content;
    if (!isItemLoaded(index)) {
      content = <CircularProgress color="inherit" />;
    } else {
      content = <Fragment>
        <ListItemAvatar>
          <Avatar className={classes.avatar}>
            {items[index].key}
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={items[index].name} />
      </Fragment>;
    }

    return (
            <ListItem button onClick={() => onClick(items[index])} divider style={style}>{content}</ListItem>
    );
  };

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={loadMoreItems}
    >
      {({ onItemsRendered, ref }) => (
        <List
          className="List"
          height={1000}
          itemCount={itemCount}
          itemSize={72}
          onItemsRendered={onItemsRendered}
          ref={ref}
        >
          {Item}
        </List>
      )}
    </InfiniteLoader>
  );
}

export default  withStyles(styles)(ExampleWrapper);